export default "__VITE_ASSET__BeMLpa5j__"